import { render, staticRenderFns } from "./AddMsg.vue?vue&type=template&id=ea8f83de"
import script from "./AddMsg.vue?vue&type=script&lang=js"
export * from "./AddMsg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports